import useProductsCheck from '@/hooks/useProductsCheck';

import type { CheckProductsProps } from './CheckProducts.types';

const CheckProducts = (props: CheckProductsProps) => {
  const { requiredProducts, children, logic } = props;

  return useProductsCheck(requiredProducts, logic) ? children : null;
};

export default CheckProducts;
